import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  connect() {
    this.nextIndex = Date.now()
  }

  add() {
    const identifier = `${this.nextIndex++}`
    const html = this.templateTarget.innerHTML.replaceAll("NEW_RECORD", identifier)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.dispatch("added")
  }

  remove(event) {
    const row = event.currentTarget.closest("[data-nested-form-row]")
    const destroyField = row.querySelector("input[name*='[_destroy]']")

    if (row.dataset.newRecord === "true") {
      row.remove()
    } else {
      destroyField.value = "1"
      // Hidden fields still take part in constraint validation, so an emptied
      // required field would block the save. Only the id and _destroy are needed.
      row.querySelectorAll("input, select, textarea, button").forEach((field) => {
        if (field !== destroyField && !field.name.endsWith("[id]")) field.disabled = true
      })
      row.hidden = true
    }
    this.dispatch("removed")
  }
}
